<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <h1 class="hdg02">無料トライアルについて</h1>
          </div>
          <div class="contact-container">
            <div class="contact-navigation">
            </div>
            <div class="contact-content">
              <p class="txt mb40">無料トライアルは、WebあるいはFAX申込書にてお申し込みいただけます。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link class="btn" to="/public/trial-application/index">Webから申し込む</router-link>
                </div>
                <div class="button contact-submit-button">
                  <a class="btn" href="/lc/app/pdf/lc_trial.pdf" target="_blank">FAX申込書をダウンロードして申し込む</a>
                </div>
              </div>
              <div class="contact-link mb40">
                <div class="contact-link-button">
                  <a href="https://www.sn-hoki.co.jp/guide/social_rules/" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </div>
                <div class="contact-link-button">
                  <a href="https://www.sn-hoki.co.jp/privacy/" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    const group1 = reactive({
    })
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact {
  &-submit {
    display: flex;
    &-button {
      margin: 0 20px;
      width: 300px;
    }
  }
  @media screen and (max-width:$width-container) {
    &-head {
      .hdg02 {
        padding-top: 20px;
      }
    }
    &-submit {
      flex-wrap: wrap;
      margin: 0 20px;
      &-button {
        max-width: 450px;
        width: 100%;
        margin: 10px 0;
      }
    }
  } 
  &-link {
    display: flex;
    padding-top: 40px;
    &-button {
      margin-right: 40px;
      a{
        color: #005BAC !important;
        text-decoration: none;
        &:hover{
          opacity: 0.7;
        }
      }
    }
  }
  @media screen and (max-width:$width-container) {
    &-link {
      flex-wrap: wrap;
      padding-top: 0;
      &-button {
        margin: 15px 0 0;
        width: 100%;
        text-align: center;
      }
    }
  } 
}
</style>
